// languageName is a translation key; render it with the translate pipe
export const LANGUAGE_LIST = [
  { languageName: "LANGUAGES.EN", language: "en", label: "EN" },
  { languageName: "LANGUAGES.ES", language: "es", label: "ES" },
  { languageName: "LANGUAGES.PT", language: "pt", label: "PT" },
  { languageName: "LANGUAGES.FR", language: "fr", label: "FR" },
  { languageName: "LANGUAGES.NL", language: "nl", label: "NL" },
  { languageName: "LANGUAGES.KO", language: "ko", label: "KO" },
  { languageName: "LANGUAGES.DE", language: "de", label: "DE" },
];
